import grapesjs from 'drapcode-builder';
import loadBlocks from './blocks';
import loadComponents from './components';
import { paginationField } from './consts';
export default grapesjs.plugins.add('gjs-pagination', (editor, opts = {}) => {
  let c = opts;

  let defaults = {
    blocks: [paginationField],
    defaultStyle: true,
    pfx: 'pagination',
    label: 'Pagination',
    category: 'CMS',
  };
  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }
  loadComponents(editor, c);
  loadBlocks(editor, c);
});
